module.exports = __webpack_public_path__ + "img/infinity_st_all_versions.7af2857a.jpg";